import { ChartDataDisplay, ChartDataInterval, ChartDataType } from "@/types/data"

export interface ChartSettings {
    dataType: ChartDataType
    dataInterval: ChartDataInterval
    dataDisplay: ChartDataDisplay
    from: Date | null
    to: Date | null
}

export interface CategoryCard {
    key: string
    category: any
    hidden: boolean
    isAvailable: boolean
    value?: any
    unit?: string
}

export interface MeasurementEntry {
    time: number
    grid?: number
    soc?: number
    productionDistribution?: {
        [key: string]: number
    }
    consumptionDistribution?: {
        [key: string]: number
    }
}

export interface ForecastEntry {
    time: number
    grid?: number
    soc?: number
    production?: number
    consumption?: number
    productionDistribution?: {
        [key: string]: number
    }
    consumptionDistribution?: {
        [key: string]: number
    }
}

export interface TooltipSyncState {
    timestamp: number | null
    isActive: boolean
    sourceChartId: string | null
}

export interface LocationChartsState {
    categories: string[]
    supportedCategories: string[]
    categoryCards: CategoryCard[]
    measurements: MeasurementEntry[]
    forecast: ForecastEntry[]
    isLoading: boolean
    error: string | null
    settings: ChartSettings
    abortController: AbortController | null
    tooltipSync: TooltipSyncState
}

export const MutationTypes = {
    SET_CATEGORIES: "SET_CATEGORIES",
    SET_SUPPORTED_CATEGORIES: "SET_SUPPORTED_CATEGORIES",
    SET_CATEGORY_CARDS: "SET_CATEGORY_CARDS",
    SET_MEASUREMENTS: "SET_MEASUREMENTS",
    SET_FORECAST: "SET_FORECAST",
    SET_LOADING: "SET_LOADING",
    SET_ERROR: "SET_ERROR",
    SET_SETTINGS: "SET_SETTINGS",
    SET_ABORT_CONTROLLER: "SET_ABORT_CONTROLLER",
    SET_TOOLTIP_SYNC: "SET_TOOLTIP_SYNC",
    CLEAR_TOOLTIP_SYNC: "CLEAR_TOOLTIP_SYNC",
}

export const ActionTypes = {
    FETCH_CHART_DATA: "FETCH_CHART_DATA",
    UPDATE_CATEGORIES: "UPDATE_CATEGORIES",
    UPDATE_SETTINGS: "UPDATE_SETTINGS",
    ABORT_FETCH: "ABORT_FETCH",
    UPDATE_TOOLTIP_POSITION: "UPDATE_TOOLTIP_POSITION",
    CLEAR_TOOLTIP: "CLEAR_TOOLTIP",
}
